enum WorkOrderTimeToComplete {
  None = "None",
  SameDay24H = "Same Day 24H",
  NextDay = "Next Day",
  Next3Days = "Next 3 Days",
  Next5Days = "Next 5 Days",
  Scheduled = "Scheduled",
}

export default WorkOrderTimeToComplete;
